// Shared cover-image framing: vertical (cover_position) + horizontal (cover_position_x)
// object-position, plus optional zoom via transform scale. Defaults center / 1x.
export function coverStyle(o, { allowZoom = true } = {}) {
  const x = o?.cover_position_x ?? 50;
  const y = o?.cover_position ?? 50;
  const z = (o?.cover_zoom ?? 100) / 100;
  const style = { objectPosition: `${x}% ${y}%` };
  if (allowZoom && z !== 1) {
    style.transform = `scale(${z})`;
    style.transformOrigin = `${x}% ${y}%`;
  }
  return style;
}
